import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets } from '../configs/constants';
import api from '../api';

const { getCancelToken } = api.buildRequestCancelation();

export const fetchSectorsStats =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.sectorsStats];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.sectorsStats, requestFilters, {
        cancelToken: getCancelToken('sectorsStats').token,
        transformResponse: (data) => ({ data: data || {} }),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };
